(function () {
  document.querySelectorAll('[data-affiliate-journey]').forEach(initJourney);

  function initJourney(root) {
    if (root._journeyInit) return;
    // AKTIVE VARIANTE: Video-Backdrop. Wenn das <video>-Element fehlt, fallback
    // auf den (auskommentierten) 3D-Canvas-Pfad — er prüft `canvas` selbst.
    const video = root.querySelector('.affiliate-journey__video');
    const canvas = root.querySelector('.affiliate-journey__canvas');
    if (!video && !canvas) return;

    root._journeyInit = true;

    const SETTINGS = {
      accent:      root.dataset.accent       || '#4f8a45',
      liquidColor: root.dataset.liquidColor  || '#e8c98a'
    };

    // ==== STATIONS / PATH (gemeinsam für Video- und 3D-Variante) ====
    const stations = Array.from(root.querySelectorAll('.station'));
    const pathEl = root.querySelector('.affiliate-journey__path');
    const pathNodes = Array.from(root.querySelectorAll('.path-node'));
    const stationRanges = [
      [0.00, 0.22],
      [0.25, 0.47],
      [0.50, 0.72],
      [0.75, 1.00]
    ];
    function updateStations(progress) {
      stations.forEach((el, i) => {
        const [start, end] = stationRanges[i];
        let alpha = 0;
        let y = 20;
        if (progress >= start && progress <= end) {
          const local = (progress - start) / (end - start);
          if (local < 0.15) alpha = local / 0.15;
          else if (local > 0.85) alpha = (1 - local) / 0.15;
          else alpha = 1;
          y = (1 - alpha) * 20;
        }
        el.style.opacity = alpha;
        el.style.transform = `translateY(${y}px)`;
      });
      let activeIdx = 0;
      for (let i = 0; i < stationRanges.length; i++) {
        if (progress >= stationRanges[i][0]) activeIdx = i;
      }
      pathNodes.forEach((node, i) => {
        node.classList.toggle('is-active', i <= activeIdx);
      });
      if (pathEl) pathEl.style.setProperty('--journey-progress', progress.toFixed(3));
    }

    /* ===========================================================================
       === DEPRECATED VIDEO-VARIANTE =============================================
       Scroll-driven MP4 + CSS-Phone-Mockup. Auskommentiert beim Switch zurück
       auf 3D. Reaktivieren:
         1) Diesen Block uncomenten
         2) DEPRECATED-3D-Block weiter unten wieder mit / *  * / wrappen
         3) Liquid: <video class="affiliate-journey__video"> + Phone-Mockup
            uncomenten, <canvas> auskommentieren, three.min.js Script-Tag
            auskommentieren.
       =========================================================================== */
    /*
    const phoneEl = root.querySelector('[data-journey-phone]');
    function updatePhone(progress) {
      let alpha = 0;
      if (progress < 0.08)      alpha = progress / 0.08;
      else if (progress < 0.20) alpha = 1;
      else if (progress < 0.30) alpha = 1 - (progress - 0.20) / 0.10;
      if (phoneEl) phoneEl.style.opacity = alpha;
    }

    if (video) {
      function waitForScroll() {
        return new Promise((resolve, reject) => {
          let tries = 0;
          (function check() {
            if (window.gsap && window.ScrollTrigger) return resolve();
            if (tries++ > 150) return reject(new Error('GSAP / ScrollTrigger not loaded'));
            setTimeout(check, 50);
          })();
        });
      }
      // Lokale Shopify-CLI-Dev-Server unterstützen keine Range-Requests für Videos
      // → der Browser kann nicht in das Video hineinspringen, jeder Seek scheitert.
      // Workaround: Video komplett als Blob in den Browser laden und eine blob:-URL
      // assignen. Blobs unterstützen Range nativ (Daten liegen im Speicher).
      // In Produktion (echtes Shopify CDN) wäre das nicht nötig, schadet aber nicht.
      function videoReady() {
        const sourceEl = video.querySelector('source');
        const sourceUrl = sourceEl && sourceEl.src;
        if (!sourceUrl) return Promise.reject(new Error('No video source'));

        const waitForMeta = () => {
          if (video.readyState >= 1 && video.duration > 0) return Promise.resolve();
          return new Promise(resolve => {
            const onReady = () => {
              if (video.readyState >= 1 && video.duration > 0) {
                video.removeEventListener('loadedmetadata', onReady);
                video.removeEventListener('canplay', onReady);
                resolve();
              }
            };
            video.addEventListener('loadedmetadata', onReady);
            video.addEventListener('canplay', onReady);
          });
        };

        return fetch(sourceUrl)
          .then(r => r.blob())
          .then(blob => {
            const blobUrl = URL.createObjectURL(blob);
            video._blobUrl = blobUrl;
            // <source>-Children entfernen damit nur die neue blob-src zählt
            while (video.firstChild) video.removeChild(video.firstChild);
            video.src = blobUrl;
            video.load();
            return waitForMeta();
          })
          .catch(err => {
            // Fallback: blob-Fetch fehlgeschlagen, hoffe dass das <source>-Element
            // mit Range-fähigem Server (Produktion) doch klappt.
            console.warn('Blob-Loader fehlgeschlagen, fallback auf <source>-src:', err);
            return waitForMeta();
          });
      }
      Promise.all([waitForScroll(), videoReady()]).then(() => {
        window.gsap.registerPlugin(window.ScrollTrigger);
        const isSmall = window.matchMedia('(max-width: 749px)').matches;

        // Decoder-Warmup: ohne einmaliges play() zeigt Safari/iOS bei manueller currentTime-
        // Manipulation nur den ersten Frame an. Muted-Autoplay ist Browser-Policy-konform.
        const warmup = video.play().then(() => video.pause()).catch(() => {});

        warmup.finally(() => {
          try { video.currentTime = 0; } catch (_) {}
          updateStations(0);
          updatePhone(0);

          const scrollTrigger = window.ScrollTrigger.create({
            trigger: root,
            start: 'top top',
            end: 'bottom bottom',
            // Scrub-Interpolation 0.8s damit Visuals dem Scroll trail-en (Cinematic-Inertia).
            // Mobile bleibt true (1:1) weil iOS-Momentum-Scroll mit scrub konflikt-anfällig ist.
            scrub: isSmallViewport ? true : 0.8,
            onUpdate: (self) => {
              // Duration pro Frame neu lesen — auf manchen Browsern wird sie erst nach
              // einigen Frames final, wir wollen kein Off-by-NaN.
              const dur = video.duration;
              if (!dur || isNaN(dur) || !isFinite(dur)) return;
              const t = self.progress * dur;
              try { video.currentTime = Math.max(0, Math.min(dur - 0.01, t)); } catch (_) {}
              updateStations(self.progress);
              updatePhone(self.progress);
            }
          });

          root._journeyCleanup = function () {
            scrollTrigger.kill();
            // Blob-URL freigeben damit der 12MB-Buffer nicht im Browser-Memory hängen bleibt
            if (video._blobUrl) {
              try { URL.revokeObjectURL(video._blobUrl); } catch (_) {}
              delete video._blobUrl;
            }
            root._journeyInit = false;
            delete root._journeyCleanup;
          };
        });
      }).catch(err => {
        console.error('Journey video init failed', err);
        root._journeyInit = false;
      });
      return;
    }
    */
    /* === END DEPRECATED VIDEO-VARIANTE ========================================= */

    /* === AKTIVE 3D-VARIANTE ==================================================== */
    function waitForLibs() {
      return new Promise((resolve, reject) => {
        let tries = 0;
        (function check() {
          if (window.THREE && window.gsap && window.ScrollTrigger) {
            return resolve({ THREE: window.THREE, gsap: window.gsap, ScrollTrigger: window.ScrollTrigger });
          }
          if (tries++ > 150) return reject(new Error('THREE / GSAP / ScrollTrigger not loaded'));
          setTimeout(check, 50);
        })();
      });
    }

    waitForLibs().then(({ THREE, gsap, ScrollTrigger }) => {
      gsap.registerPlugin(ScrollTrigger);

      // ==== Lenis Smooth-Scroll ====
      // Wenn Lenis verfügbar ist, ersetze den nativen Scroll durch interpoliertes Smooth-Scroll.
      // Singleton: nur einmal pro Page initialisieren auch wenn mehrere Sections die Lib laden.
      // Wire mit ScrollTrigger zusammen damit Triggers korrekt fire-n während Lenis interpoliert.
      if (window.Lenis && !window.__lenisInstance) {
        const lenis = new window.Lenis({
          duration: 1.1,           // Smoothness-Trägheit (höher = mehr Trail)
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
          smoothWheel: true,
          smoothTouch: false       // Touch-Mobile: native Momentum belassen, kein Lenis-Konflikt
        });
        window.__lenisInstance = lenis;
        lenis.on('scroll', ScrollTrigger.update);
        gsap.ticker.add((time) => lenis.raf(time * 1000));
        gsap.ticker.lagSmoothing(0); // wichtig damit Lenis exakte Frame-Times kriegt
      }

      const isSmallViewport = window.matchMedia('(max-width: 749px)').matches;
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      let width = 1, height = 1;

      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(40, 1, 0.1, 100);
      camera.position.set(0, 0, 3.5);
      camera.lookAt(0, 0, 0);

      // ==== CAMERA-CHOREOGRAFIE (cinematic shots pro Phase) ====
      // Statt statischer Kamera mit Mini-Parallax: 5 definierte Shot-Targets, smooth
      // interpoliert basierend auf Scroll-Progress. Gibt der Szene Regie statt nur Bühne.
      //
      // Pro Shot: Camera-Position + LookAt-Target. Beides wird zwischen den Keyframes
      // gelerpt (mit smooth easing). Werte sind moderat — wir wollen Bewegung
      // wahrnehmbar aber nicht überstürzt (Documentary-Pacing, nicht Action-Movie).
      // 4 stabile Shots, einer pro Phase. Jeder Shot HOLD lange in seiner Phase und
      // glide-t dann smooth zur nächsten Position über einen weiten Übergangs-Korridor.
      // Premium-Pacing = wenig Bewegung innerhalb einer Szene, ruhige Transitions zwischen ihnen.
      const V = (x, y, z) => new THREE.Vector3(x, y, z);

      // Pro Shot: Anker-Position + LookAt-Target. Dasselbe Keyframe-Paar (Start + Ende der
      // Phase) → smoothstep produziert dazwischen Stillstand.
      // Mobile-Anpassungen: Portrait-Viewport hat ~50% der Desktop-Breite. Camera muss
      // weiter zurück damit Action seitlich nicht beschnitten wird, X/Y-Shifts gedämpft
      // damit Action im engen Frame nicht aus dem Bild wandert.
      const mobZ  = isSmallViewport ? 1.5 : 0;
      const mobXY = isSmallViewport ? 0.45 : 1.0;

      const SHOT_A_POS  = V( 0.25 * mobXY, 0.15 * mobXY, 2.80 + mobZ);  // Phase 1: Creator mit Phone
      const SHOT_A_LOOK = V(-0.30 * mobXY, 0.00,         0.00);
      const SHOT_B_POS  = V( 0.20 * mobXY, 0.05 * mobXY, 2.50 + mobZ);  // Phase 2: Cursor-Tap
      const SHOT_B_LOOK = V( 0.15 * mobXY, 0.00,         0.00);
      const SHOT_C_POS  = V(-0.20 * mobXY, 0.30 * mobXY, 3.80 + mobZ);  // Phase 3: Karton-Choreografie
      const SHOT_C_LOOK = V( 0.00,         0.00,        -1.00);
      const SHOT_D_POS  = V(-0.30 * mobXY, 0.00,         3.10 + mobZ);  // Phase 4: Münzen zum Creator
      const SHOT_D_LOOK = V(-0.70 * mobXY, 0.00,         0.20);

      const camKeys = [
        // Shot A — Hold von 0% bis 20%, dann sanfter Glide bis 32%
        { p: 0.00, pos: SHOT_A_POS, look: SHOT_A_LOOK },
        { p: 0.20, pos: SHOT_A_POS, look: SHOT_A_LOOK },
        // Shot B — Hold von 32% bis 45%, Glide bis 58%
        { p: 0.32, pos: SHOT_B_POS, look: SHOT_B_LOOK },
        { p: 0.45, pos: SHOT_B_POS, look: SHOT_B_LOOK },
        // Shot C — Hold von 58% bis 82%, Glide bis 94%
        { p: 0.58, pos: SHOT_C_POS, look: SHOT_C_LOOK },
        { p: 0.82, pos: SHOT_C_POS, look: SHOT_C_LOOK },
        // Shot D — Hold von 94% bis 100%
        { p: 0.94, pos: SHOT_D_POS, look: SHOT_D_LOOK },
        { p: 1.00, pos: SHOT_D_POS, look: SHOT_D_LOOK }
      ];
      // applyCameraShot setzt nur noch die TARGET-Werte, nicht die Camera direkt.
      // Die finale Kamera-Position wird in applyCameraFinal() (Render-Loop) gesetzt:
      // target + smooth-gelerpter Mouse-Offset. So koexistieren Shot-Choreografie und
      // Mouse-Parallax sauber statt sich gegenseitig zu überschreiben.
      const camTargetPos = new THREE.Vector3();
      const camTargetLook = new THREE.Vector3();
      const camMouseTarget = new THREE.Vector3();   // wo Mouse uns hin will
      const camMouseCurrent = new THREE.Vector3();  // smooth-gelerpter Offset
      const camFinalPos = new THREE.Vector3();
      function easeInOut(t) { return t * t * (3 - 2 * t); }
      function applyCameraShot(p) {
        if (p <= camKeys[0].p) {
          camTargetPos.copy(camKeys[0].pos);
          camTargetLook.copy(camKeys[0].look);
          return;
        }
        if (p >= camKeys[camKeys.length - 1].p) {
          const last = camKeys[camKeys.length - 1];
          camTargetPos.copy(last.pos);
          camTargetLook.copy(last.look);
          return;
        }
        for (let i = 0; i < camKeys.length - 1; i++) {
          const a = camKeys[i], b = camKeys[i + 1];
          if (p >= a.p && p <= b.p) {
            const t = easeInOut((p - a.p) / (b.p - a.p));
            camTargetPos.copy(a.pos).lerp(b.pos, t);
            camTargetLook.copy(a.look).lerp(b.look, t);
            return;
          }
        }
      }
      // Mouse-Tracking: nur auf hover-fähigen Geräten, sonst Touch-Scroll-Konflikte
      const mouseNorm = { x: 0, y: 0, active: false };
      const hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (hasFinePointer) {
        root.addEventListener('pointermove', e => {
          if (e.pointerType !== 'mouse') return;
          const r = root.getBoundingClientRect();
          mouseNorm.x = ((e.clientX - r.left) / r.width) * 2 - 1;
          mouseNorm.y = -(((e.clientY - r.top) / r.height) * 2 - 1);
          mouseNorm.active = true;
        });
        root.addEventListener('pointerleave', () => { mouseNorm.active = false; });
      }
      // applyCameraFinal: pro Frame im Render-Loop. Smooth-lerpt Mouse-Offset zur Target-Position
      // und addiert es auf den Shot-Anchor. Niedrige lerp-Rate (0.05) = sanftes Trailing.
      // Impact-Decay-Helper: 0 bei elapsed=0 → 1 bei peak (15ms in) → 0 bei DURATION end.
      // Quick attack, slow release — fühlt sich wie ein echter „Impact" an, nicht wie Sin.
      function impactAmount(now) {
        const elapsed = now - impactTime;
        if (elapsed < 0 || elapsed > IMPACT_DURATION) return 0;
        const local = elapsed / IMPACT_DURATION;
        if (local < 0.04) return local / 0.04;          // attack 0→1 in ersten 4%
        return Math.pow(1 - (local - 0.04) / 0.96, 1.8); // release mit power-curve
      }

      function applyCameraFinal() {
        if (mouseNorm.active) {
          camMouseTarget.set(mouseNorm.x * 0.40, mouseNorm.y * 0.22, 0);
        } else {
          camMouseTarget.set(0, 0, 0);
        }
        camMouseCurrent.lerp(camMouseTarget, 0.09);
        camFinalPos.copy(camTargetPos).add(camMouseCurrent);
        // Camera-Shake bei Impact: high-frequency random Offset, decays mit impactAmount
        const now = performance.now();
        const shake = impactAmount(now) * 0.06;
        if (shake > 0.001) {
          camFinalPos.x += (Math.random() - 0.5) * shake;
          camFinalPos.y += (Math.random() - 0.5) * shake;
        }
        camera.position.copy(camFinalPos);
        camera.lookAt(camTargetLook);
        // Light-Flash bei Impact: keyLight pumpt von Base auf +2.5 hoch und decays
        keyLight.intensity = KEY_LIGHT_BASE + impactAmount(now) * 2.5;

        // BG-Layer-Compensation: BG-Planes folgen der TOTAL-Camera-Verschiebung (Shot + Mouse)
        // teilweise mit. Vorher wurde nur Mouse kompensiert → Camera-Shot-Y-Sprünge (z.B. Shot C
        // bei y=0.30) haben die Plane-Edges in den Viewport gezogen.
        const totalCamX = camTargetPos.x + camMouseCurrent.x;
        const totalCamY = camTargetPos.y + camMouseCurrent.y;
        if (bgFarMesh) {
          bgFarMesh.position.x = totalCamX * 0.85;
          bgFarMesh.position.y = (bgFarMesh.userData.scrollY || 0) + totalCamY * 0.85;
        }
        if (bgMidMesh) {
          bgMidMesh.position.x = totalCamX * 0.70;
          bgMidMesh.position.y = (bgMidMesh.userData.scrollY || 0) + totalCamY * 0.70;
        }
      }

      const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
      renderer.setPixelRatio(dpr);
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.0;

      // ==== POSTPROCESSING (EffectComposer mit UnrealBloom) ====
      // Nur Bloom aktiv — größter Visueller Impact pro GPU-Cost.
      // SSAO + DOF deaktiviert weil:
      //   - SSAO sättigt die GPU (Multi-Sample Depth/Normal-Loop pro Pixel)
      //   - DOF (Bokeh) ähnlich teuer + erfordert Depth-Texture
      // Können später wieder rein wenn die User-GPU es packt — die Module sind im Bundle drin.
      // GammaCorrection-Pass am Ende — Composer arbeitet linear, ohne Gamma wäre alles zu dunkel.

      // Environment — Studio-Setup im Equirectangular-Layout: warmer Sky-Gradient oben,
      // dunkler Horizontstreifen, goldener Bodenbereich; darüber 3 weiche Lichtquellen
      // (Key oben-links, Fill oben-rechts, Rim hinten unten) gemalt mit großzügigen
      // RadialGradients statt harten Kreisen — gibt rich Highlights auf rauhen Materials
      // statt scharfer Reflex-Punkte. Auflösung 1024×512 (= echtes equirect 2:1).
      function buildEnv() {
        const W = 1024, H = 512;
        const c = document.createElement('canvas');
        c.width = W; c.height = H;
        const cx = c.getContext('2d');

        // Vertical sky-to-ground gradient
        const sky = cx.createLinearGradient(0, 0, 0, H);
        sky.addColorStop(0.00, '#fff9e6'); // sky top
        sky.addColorStop(0.12, '#fce7b4');
        sky.addColorStop(0.30, '#3a2510'); // dark horizon-shadow band oben
        sky.addColorStop(0.48, '#1f1408'); // tiefster dunkler Bereich
        sky.addColorStop(0.55, '#5b3c18'); // horizon glow start
        sky.addColorStop(0.65, '#e0a85c'); // warm horizon line
        sky.addColorStop(0.80, '#c08840');
        sky.addColorStop(1.00, '#2d1d0a'); // ground deep
        cx.fillStyle = sky;
        cx.fillRect(0, 0, W, H);

        // Helper: weicher Lichtfleck via RadialGradient
        function softLight(x, y, r, color, alpha) {
          const g = cx.createRadialGradient(x, y, 0, x, y, r);
          g.addColorStop(0,    color.replace(')', `, ${alpha})`).replace('rgb', 'rgba'));
          g.addColorStop(0.5,  color.replace(')', `, ${alpha * 0.4})`).replace('rgb', 'rgba'));
          g.addColorStop(1,    color.replace(')', ', 0)').replace('rgb', 'rgba'));
          cx.fillStyle = g;
          cx.beginPath(); cx.arc(x, y, r, 0, Math.PI * 2); cx.fill();
        }

        // Key Light: groß + warm, oben-links (im equirect: x ~25%, y ~18%)
        softLight(W * 0.22, H * 0.18, W * 0.22, 'rgb(255, 248, 220)', 0.95);
        // Fill: kleiner, kühler weiß, oben-rechts
        softLight(W * 0.72, H * 0.22, W * 0.16, 'rgb(255, 250, 240)', 0.65);
        // Rim: warm low gold, gegenüber (für Backlight auf der Rückseite der Objekte)
        softLight(W * 0.50, H * 0.62, W * 0.20, 'rgb(255, 200, 120)', 0.7);
        // Subtle accent kicks für Lebendigkeit in den Glas-Reflexionen
        softLight(W * 0.05, H * 0.40, W * 0.08, 'rgb(255, 220, 160)', 0.5);
        softLight(W * 0.92, H * 0.55, W * 0.07, 'rgb(255, 230, 180)', 0.5);

        const tex = new THREE.CanvasTexture(c);
        tex.mapping = THREE.EquirectangularReflectionMapping;
        tex.encoding = THREE.sRGBEncoding;
        return tex;
      }
      // Canvas-baked Environment durch PMREM für IBL/Reflexionen.
      const pmrem = new THREE.PMREMGenerator(renderer);
      pmrem.compileEquirectangularShader();
      const rawEnv = buildEnv();
      const envRT = pmrem.fromEquirectangular(rawEnv);
      scene.environment = envRT.texture;
      rawEnv.dispose();
      pmrem.dispose();

      // ==== Cinematic 3-Layer Parallax Backdrop ====
      // Statt procedural Shader: 3 fotografische Layer aus den vom User gelieferten Bildern.
      //   - Far  (z=-8):  warm Gold-Atmosphäre mit Dust-Particles, opak. Visible Backdrop.
      //   - Mid  (z=-4):  Goldene Lichtstrahlen aus Ecken, additiv geblendet (Schwarz wird transparent).
      //   - Fore (z=+1.5): Bokeh-Spots in Ecken, additiv geblendet, subtle Foreground-Detail.
      // Pro Layer eigene Parallax-Geschwindigkeit basierend auf Scroll-Progress → 3D-Depth-Feel.
      const texLoader = new THREE.TextureLoader();
      let bgFarMesh = null, bgMidMesh = null, bgForeMesh = null;
      // Anchor-Y damit applyFloat / parallax sauber draufrechnen ohne sich zu addieren
      function loadBgLayer(url, opts) {
        return new Promise(resolve => {
          if (!url) return resolve(null);
          texLoader.load(url, tex => {
            tex.encoding = THREE.sRGBEncoding;
            tex.minFilter = THREE.LinearMipmapLinearFilter;
            tex.magFilter = THREE.LinearFilter;
            tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
            const mat = new THREE.MeshBasicMaterial({
              map: tex,
              transparent: opts.transparent || false,
              depthWrite: opts.depthWrite !== undefined ? opts.depthWrite : true,
              depthTest: true,
              blending: opts.blending || THREE.NormalBlending,
              opacity: opts.opacity != null ? opts.opacity : 1.0
            });
            const mesh = new THREE.Mesh(new THREE.PlaneGeometry(opts.w, opts.h), mat);
            mesh.position.set(0, 0, opts.z);
            mesh.renderOrder = opts.renderOrder;
            mesh.userData.anchorY = 0;
            mesh.userData.parallaxAmp = opts.parallaxAmp;
            scene.add(mesh);
            resolve(mesh);
          });
        });
      }
      loadBgLayer(root.dataset.bgFar, {
        w: 28, h: 16, z: -8, renderOrder: -100,
        parallaxAmp: 0.10
      }).then(m => { bgFarMesh = m; });
      // Mid plane: w/h werden später aspect-aware via sizeMidPlane() überschrieben.
      // Initial-Größe nur Placeholder bis erste resize() aufgerufen wird.
      loadBgLayer(root.dataset.bgMid, {
        w: 1, h: 1, z: -4, renderOrder: -50,
        transparent: true, depthWrite: false,
        blending: THREE.AdditiveBlending,
        opacity: 0.85,
        parallaxAmp: 0.30
      }).then(m => { bgMidMesh = m; sizeMidPlane(); });
      const MID_Z = -4;
      const MID_IMAGE_ASPECT = 16 / 9;
      function sizeMidPlane() {
        if (!bgMidMesh) return;
        const distToPlane = (isSmallViewport ? 5.30 : 3.80) - MID_Z;
        const fovRad = camera.fov * Math.PI / 180;
        const visibleH = 2 * distToPlane * Math.tan(fovRad / 2);
        const visibleW = visibleH * camera.aspect;
        // Margin 1.45 statt 1.20 — gibt mehr Reserve für extreme Camera-Y-Shifts (Shot C)
        // + Mouse-Parallax + Scroll-Parallax zusammen.
        let planeH, planeW;
        if (visibleW / visibleH > MID_IMAGE_ASPECT) {
          planeW = visibleW * 1.45;
          planeH = planeW / MID_IMAGE_ASPECT;
        } else {
          planeH = visibleH * 1.45;
          planeW = planeH * MID_IMAGE_ASPECT;
        }
        bgMidMesh.scale.set(planeW, planeH, 1);
      }
      // Foreground: camera-attached, Plane-Größe wird aspect-aware berechnet damit Bokeh-Corners
      // im Bild EXAKT an den Viewport-Ecken landen. Color-Multiplier (>1.0) boost die Bokeh-
      // Helligkeit damit sie auf dem hellen Backdrop sichtbar bleiben (additive Blending sonst
      // gegen Gold + Gold = saturated, kaum Delta).
      const FORE_DISTANCE = 2;
      const FORE_IMAGE_ASPECT = 16 / 9; // Bild ist im 16:9-Format gespeichert
      function sizeForePlane() {
        if (!bgForeMesh) return;
        const fovRad = camera.fov * Math.PI / 180;
        const visibleH = 2 * FORE_DISTANCE * Math.tan(fovRad / 2);
        const visibleW = visibleH * camera.aspect;
        // Cover-fit: skaliere uniform sodass das 16:9-Image den Viewport komplett abdeckt
        // (auf Portrait überlappt's links/rechts, auf Landscape oben/unten — Aspect bleibt erhalten).
        let planeH, planeW;
        if (visibleW / visibleH > FORE_IMAGE_ASPECT) {
          // Viewport breiter als Image → match Width, Height overflows
          planeW = visibleW * 1.05;
          planeH = planeW / FORE_IMAGE_ASPECT;
        } else {
          // Viewport schmaler/gleich als Image → match Height, Width overflows
          planeH = visibleH * 1.05;
          planeW = planeH * FORE_IMAGE_ASPECT;
        }
        bgForeMesh.scale.set(planeW, planeH, 1);
      }
      texLoader.load(root.dataset.bgFore, foreTex => {
        foreTex.encoding = THREE.sRGBEncoding;
        foreTex.minFilter = THREE.LinearMipmapLinearFilter;
        foreTex.magFilter = THREE.LinearFilter;
        foreTex.anisotropy = renderer.capabilities.getMaxAnisotropy();
        const mat = new THREE.MeshBasicMaterial({
          map: foreTex, transparent: true, depthWrite: false, depthTest: false,
          blending: THREE.AdditiveBlending,
          opacity: 1.0,
          color: new THREE.Color(2.0, 2.0, 2.0) // Texture um Faktor 2 boosten → Bokeh stechen heraus
        });
        // Unit-Size Plane, wird via sizeForePlane() auf exakte Viewport-Größe skaliert.
        bgForeMesh = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), mat);
        bgForeMesh.position.set(0, 0, -FORE_DISTANCE);
        bgForeMesh.renderOrder = 100;
        bgForeMesh.userData.parallaxAmp = 0.04; // sehr subtle (5% margin reicht nur für ~0.04)
        camera.add(bgForeMesh);
        sizeForePlane();
      });
      // Camera muss zur Scene hinzugefügt werden damit ihre Children gerendert werden
      scene.add(camera);

      function applyParallax(p) {
        // p = scroll progress 0..1. Map to -1..+1 für symmetrische Bewegung
        const offset = (p - 0.5) * 2;
        // Scroll-Y in userData speichern; das finale position.y wird in applyCameraFinal
        // mit der Mouse-Camera-Compensation kombiniert (BG folgt Camera teilweise mit, damit
        // die Layer-Kanten beim Mouse-Parallax nicht ins Bild driften).
        if (bgFarMesh)  bgFarMesh.userData.scrollY  = -offset * bgFarMesh.userData.parallaxAmp;
        if (bgMidMesh)  bgMidMesh.userData.scrollY  = -offset * bgMidMesh.userData.parallaxAmp;
        if (bgForeMesh) bgForeMesh.position.y = -offset * bgForeMesh.userData.parallaxAmp;
      }
      // Stub für Backdrop-Shader-Reference die aus applyFloat aufgerufen wird
      const backdropMat = null;

      // ==== Klassische 3-Punkt-Beleuchtung (Studio) ====
      scene.add(new THREE.AmbientLight(0xfff2e0, 0.35));
      // Key: Hauptlicht von oben-links, warm, der Schatten-Caster auf Desktop
      const KEY_LIGHT_BASE = 1.4;
      const keyLight = new THREE.DirectionalLight(0xfff5dd, KEY_LIGHT_BASE);
      keyLight.position.set(-2.2, 3.5, 3.0);
      scene.add(keyLight);
      // Fill: kühler, gegenüber, schwächer — füllt die Schattenseite ohne sie zu killen
      const fillLight = new THREE.DirectionalLight(0xe6f0ff, 0.45);
      fillLight.position.set(2.5, 1.5, 3.5);
      scene.add(fillLight);
      // Rim: warm hinten unten — Backlight für die Glaskanten und Iridescent-Schimmer
      const rimLight = new THREE.DirectionalLight(0xffd089, 0.7);
      rimLight.position.set(0.5, -0.8, -2.5);
      scene.add(rimLight);


      // ==== FLASCHE ====
      // Schlankere, detailliertere Silhouette: Heel-Ring unten, sanfter Schulter-Übergang
      // (4 Punkte statt 2), schmaler Hals mit Lip-Flare oben.
      const bottleProfile = [
        new THREE.Vector2(0,     -0.60),  // closed bottom center
        new THREE.Vector2(0.16,  -0.600), // heel inset
        new THREE.Vector2(0.22,  -0.585), // heel curve
        new THREE.Vector2(0.245, -0.555), // heel ring max
        new THREE.Vector2(0.25,  -0.510), // body straight start
        new THREE.Vector2(0.25,   0.050), // body straight end
        new THREE.Vector2(0.245,  0.130), // shoulder begin
        new THREE.Vector2(0.232,  0.200), // shoulder mid
        new THREE.Vector2(0.200,  0.270), // shoulder transition
        new THREE.Vector2(0.155,  0.340), // neck base
        new THREE.Vector2(0.120,  0.410), // neck narrow
        new THREE.Vector2(0.118,  0.600), // neck straight up to lip
        new THREE.Vector2(0.138,  0.635), // lip flare out
        new THREE.Vector2(0.142,  0.660), // lip top edge
        new THREE.Vector2(0.130,  0.680)  // top inward taper
      ];
      const bottleGeo = new THREE.LatheGeometry(bottleProfile, 32);
      const bottleMat = new THREE.MeshPhysicalMaterial({
        color: 0xfff3d6,
        transmission: 1.0,
        roughness: 0.03,
        thickness: 0.8,
        ior: 1.38,
        clearcoat: 1.0,
        clearcoatRoughness: 0.06,
        metalness: 0.0,
        // Warmes Cream-Amber statt Brand-Grün — accent (Logo-Color) ist für UI-Elemente,
        // als Glas-Tönung würde es die Flasche wie eine grüne Bierflasche aussehen lassen.
        attenuationColor: new THREE.Color(0xf6d8a0),
        attenuationDistance: 1.2,
        envMapIntensity: 2.6,
        iridescence: 0.9,
        iridescenceIOR: 1.3,
        iridescenceThicknessRange: [300, 300],
        transparent: true
      });
      const bottle = new THREE.Mesh(bottleGeo, bottleMat);

      // Inneres Liquid an die schlankere Body-Innenwand angepasst
      const liquidProfile = [
        new THREE.Vector2(0,     -0.58),
        new THREE.Vector2(0.218, -0.58),
        new THREE.Vector2(0.228,  0.050),
        new THREE.Vector2(0,      0.050)
      ];
      const liquidGeo = new THREE.LatheGeometry(liquidProfile, 24);
      // Liquid bewusst opak (kein transmission) — hinter Glaswand + Label kaum als
      // refraktiv erkennbar, spart einen kompletten Transmission-Pass pro Frame.
      const liquidMat = new THREE.MeshStandardMaterial({
        color: new THREE.Color(SETTINGS.liquidColor),
        roughness: 0.35,
        metalness: 0.0,
        envMapIntensity: 1.4,
        transparent: true,
        opacity: 0.92
      });
      const liquid = new THREE.Mesh(liquidGeo, liquidMat);

      // Cap aus drei Lagen: Skirt-Rim (untere Krempe), Hauptkörper, Crown-Bevel oben.
      // Durchmesser knapp über der Mündungslippe (0.142 → ~0.146) damit kein harter Stufen-
      // sprung Lippe→Cap entsteht. Skirt sitzt direkt auf der Lippe.
      const capMat = new THREE.MeshStandardMaterial({
        color: 0x2f2924, roughness: 0.42, metalness: 0.38
      });
      const capGroup = new THREE.Group();
      const capSkirt = new THREE.Mesh(new THREE.CylinderGeometry(0.148, 0.152, 0.020, 48), capMat);
      capSkirt.position.y = 0.660;
      const capBody = new THREE.Mesh(new THREE.CylinderGeometry(0.146, 0.146, 0.078, 48), capMat);
      capBody.position.y = 0.709;
      const capCrown = new THREE.Mesh(new THREE.CylinderGeometry(0.130, 0.146, 0.018, 48), capMat);
      capCrown.position.y = 0.757;
      capGroup.add(capSkirt);
      capGroup.add(capBody);
      capGroup.add(capCrown);

      // Papier-Label um den Bauch — warmes Cream-Paper als Untergrund, das echte Fermania-Logo
      // wird asynchron drüber gezeichnet. Bewusst minimal: keine Apotheken-Siegel, keine
      // medizinisch wirkende Serif-Typografie.
      const lblCanvas = document.createElement('canvas');
      lblCanvas.width = 1024; lblCanvas.height = 256;
      const lcx = lblCanvas.getContext('2d');

      function paintLabelBase() {
        lcx.fillStyle = '#f4e9cc';
        lcx.fillRect(0, 0, 1024, 256);
        // Subtile Papier-Faserung
        for (let i = 0; i < 110; i++) {
          lcx.fillStyle = `rgba(80, 50, 20, ${0.03 + Math.random() * 0.05})`;
          lcx.beginPath();
          lcx.arc(Math.random() * 1024, Math.random() * 256, 0.5 + Math.random() * 1.1, 0, Math.PI * 2);
          lcx.fill();
        }
        // Sehr dezente, dünne Akzent-Linien oben/unten — Editorial, nicht klinisch
        lcx.strokeStyle = 'rgba(70, 45, 18, 0.22)';
        lcx.lineWidth = 1;
        lcx.beginPath(); lcx.moveTo(40, 18);  lcx.lineTo(984, 18);  lcx.stroke();
        lcx.beginPath(); lcx.moveTo(40, 238); lcx.lineTo(984, 238); lcx.stroke();
      }
      paintLabelBase();

      const lblTex = new THREE.CanvasTexture(lblCanvas);
      lblTex.encoding = THREE.sRGBEncoding;

      // Logo asynchron laden + zentriert reinmalen, sobald da. CrossOrigin nötig damit das
      // Canvas nicht "tainted" wird und als WebGL-Textur unbenutzbar wird.
      const logoUrl = root.dataset.logoUrl;
      if (logoUrl) {
        const logoImg = new Image();
        logoImg.crossOrigin = 'anonymous';
        logoImg.onload = function () {
          const targetW = 620;
          const aspect = logoImg.width / logoImg.height;
          const targetH = targetW / aspect;
          const x = (1024 - targetW) / 2;
          const y = (256 - targetH) / 2;
          lcx.drawImage(logoImg, x, y, targetW, targetH);
          lblTex.needsUpdate = true;
        };
        logoImg.onerror = function () {
          // Fallback: Wordmark, falls CDN/CORS scheitert
          lcx.fillStyle = '#2d3a20';
          lcx.textAlign = 'center';
          lcx.textBaseline = 'middle';
          lcx.font = '700 56px Georgia, serif';
          lcx.fillText('Fermania', 512, 128);
          lblTex.needsUpdate = true;
        };
        logoImg.src = logoUrl;
      }

      const labelMat = new THREE.MeshStandardMaterial({
        map: lblTex, roughness: 0.85, metalness: 0.0
      });
      // Höher (0.20 → 0.40) damit es proportional zur Flaschenbreite stimmt und einen echten
      // Bauch-Wickel ergibt statt eines schmalen Bandes.
      const labelGeo = new THREE.CylinderGeometry(0.252, 0.252, 0.40, 64, 1, true);
      const label = new THREE.Mesh(labelGeo, labelMat);
      label.position.y = -0.20;

      const bottleGroup = new THREE.Group();
      bottleGroup.add(bottle);
      bottleGroup.add(liquid);
      bottleGroup.add(label);
      bottleGroup.add(capGroup);
      scene.add(bottleGroup);

      // ==== PHONE mit ANIMIERTEM REEL ====
      const phoneGroup = new THREE.Group();
      const phoneShape = new THREE.Shape();
      const pw = 0.55, ph = 1.0, pr = 0.08;
      phoneShape.moveTo(-pw/2 + pr, -ph/2);
      phoneShape.lineTo( pw/2 - pr, -ph/2);
      phoneShape.quadraticCurveTo( pw/2, -ph/2,  pw/2, -ph/2 + pr);
      phoneShape.lineTo( pw/2,  ph/2 - pr);
      phoneShape.quadraticCurveTo( pw/2,  ph/2,  pw/2 - pr,  ph/2);
      phoneShape.lineTo(-pw/2 + pr,  ph/2);
      phoneShape.quadraticCurveTo(-pw/2,  ph/2, -pw/2,  ph/2 - pr);
      phoneShape.lineTo(-pw/2, -ph/2 + pr);
      phoneShape.quadraticCurveTo(-pw/2, -ph/2, -pw/2 + pr, -ph/2);
      const phoneGeo = new THREE.ExtrudeGeometry(phoneShape, { depth: 0.06, bevelEnabled: true, bevelThickness: 0.01, bevelSize: 0.01, bevelSegments: 3 });
      const phoneMat = new THREE.MeshStandardMaterial({ color: 0x1a1a1a, roughness: 0.3, metalness: 0.5 });
      const phone = new THREE.Mesh(phoneGeo, phoneMat);
      phoneGroup.add(phone);

      // Screen: entweder VideoTexture (wenn user-video hochgeladen) oder animated canvas fallback
      const videoEl = root.querySelector('[data-journey-video]');
      let reelTex = null;
      let reelCanvas = null;
      let rcx = null;
      const useVideo = !!videoEl;

      if (useVideo) {
        // Versuche direkt abspielen (muted autoplay ist meist erlaubt)
        videoEl.play().catch(() => {});
        reelTex = new THREE.VideoTexture(videoEl);
        reelTex.minFilter = THREE.LinearFilter;
        reelTex.magFilter = THREE.LinearFilter;
        reelTex.encoding = THREE.sRGBEncoding;
      } else {
        reelCanvas = document.createElement('canvas');
        reelCanvas.width = 192;
        reelCanvas.height = 352;
        rcx = reelCanvas.getContext('2d');
        reelTex = new THREE.CanvasTexture(reelCanvas);
        reelTex.encoding = THREE.sRGBEncoding;
      }
      const screenGeo = new THREE.PlaneGeometry(0.48, 0.88);
      const screenMat = new THREE.MeshBasicMaterial({ map: reelTex });
      const screen = new THREE.Mesh(screenGeo, screenMat);
      // Phone-Frontfläche liegt bei z = depth (0.06) + bevelThickness (0.01) = 0.07.
      // Screen muss eindeutig davor liegen, sonst Z-Fighting → Schachbrett-Pixelmuster.
      screen.position.z = 0.0775;
      phoneGroup.add(screen);

      function drawReel(t) {
        const W = reelCanvas.width;
        const H = reelCanvas.height;
        // Hintergrund: warmer Farbverlauf, shift langsam
        const hueShift = (t * 0.02) % 40;
        const g = rcx.createLinearGradient(0, 0, 0, H);
        g.addColorStop(0, `hsl(${30 + hueShift}, 60%, 70%)`);
        g.addColorStop(0.6, `hsl(${20 + hueShift}, 50%, 55%)`);
        g.addColorStop(1, `hsl(${15 + hueShift}, 45%, 40%)`);
        rcx.fillStyle = g;
        rcx.fillRect(0, 0, W, H);

        // Fake "Flasche" Silhouette in der Mitte, bobbing
        const cy = H * 0.5 + Math.sin(t * 0.002) * 6;
        rcx.fillStyle = 'rgba(255, 242, 188, 0.85)';
        rcx.beginPath();
        rcx.moveTo(W * 0.44, cy - 55);
        rcx.lineTo(W * 0.44, cy - 40);
        rcx.quadraticCurveTo(W * 0.38, cy - 28, W * 0.38, cy - 18);
        rcx.lineTo(W * 0.38, cy + 60);
        rcx.lineTo(W * 0.62, cy + 60);
        rcx.lineTo(W * 0.62, cy - 18);
        rcx.quadraticCurveTo(W * 0.62, cy - 28, W * 0.56, cy - 40);
        rcx.lineTo(W * 0.56, cy - 55);
        rcx.closePath();
        rcx.fill();

        // Progress-bar oben
        const prog = ((t * 0.0004) % 1);
        rcx.fillStyle = 'rgba(255, 255, 255, 0.25)';
        rcx.fillRect(10, 12, W - 20, 2.5);
        rcx.fillStyle = 'rgba(255, 255, 255, 0.95)';
        rcx.fillRect(10, 12, (W - 20) * prog, 2.5);

        // @-handle top left
        rcx.font = '9px system-ui, sans-serif';
        rcx.fillStyle = 'rgba(255, 255, 255, 0.88)';
        rcx.textAlign = 'left';
        rcx.fillText('@fermania', 10, 30);

        // Side icons (heart pulsing, comment, share)
        const pulse = 1 + Math.sin(t * 0.005) * 0.15;
        rcx.font = `${Math.round(20 * pulse)}px system-ui`;
        rcx.textAlign = 'center';
        rcx.fillStyle = 'rgba(255, 90, 90, 0.95)';
        rcx.fillText('♥', W - 22, H - 76);
        rcx.font = '16px system-ui';
        rcx.fillStyle = 'rgba(255, 255, 255, 0.9)';
        rcx.fillText('💬', W - 22, H - 50);
        rcx.fillText('↗', W - 22, H - 26);

        reelTex.needsUpdate = true;
      }
      if (!useVideo) drawReel(0);

      // Phone X gedämpft auf Mobile damit es im engeren Portrait-Frame nicht beschnitten wird
      const PHONE_X_FACTOR = isSmallViewport ? 0.55 : 1.0;
      phoneGroup.position.set(-0.9 * PHONE_X_FACTOR, 0, -0.5);
      phoneGroup.scale.setScalar(0);
      scene.add(phoneGroup);

      // ==== CURSOR (Station 2) ====
      const cursorGroup = new THREE.Group();
      const tapGeo = new THREE.RingGeometry(0.08, 0.1, 32);
      const tapMat = new THREE.MeshBasicMaterial({ color: SETTINGS.accent, transparent: true, opacity: 0.9, side: THREE.DoubleSide });
      const tapRing = new THREE.Mesh(tapGeo, tapMat);
      cursorGroup.add(tapRing);
      const tapDotGeo = new THREE.CircleGeometry(0.05, 24);
      const tapDotMat = new THREE.MeshBasicMaterial({ color: SETTINGS.accent });
      const tapDot = new THREE.Mesh(tapDotGeo, tapDotMat);
      cursorGroup.add(tapDot);
      cursorGroup.position.set(0.5, 0.2, 0.3);
      cursorGroup.scale.setScalar(0);
      scene.add(cursorGroup);

      // ==== KARTON mit KLAPPEN + TEXTUR ====
      const boxGroup = new THREE.Group();
      const boxSize = 1.2; // knapp größer als die flasche in phase 3 (bottleScale 0.55)

      // Karton-Textur (Canvas)
      const cardCanvas = document.createElement('canvas');
      cardCanvas.width = 256;
      cardCanvas.height = 256;
      const ccx = cardCanvas.getContext('2d');
      ccx.fillStyle = '#c49a64';
      ccx.fillRect(0, 0, 256, 256);
      // Cardboard-wellen (subtile linien)
      for (let i = 0; i < 16; i++) {
        const y = i * 17 + Math.random() * 4;
        ccx.strokeStyle = `rgba(${80 + Math.random()*20}, ${55 + Math.random()*15}, 30, ${0.12 + Math.random() * 0.08})`;
        ccx.lineWidth = 1;
        ccx.beginPath();
        ccx.moveTo(0, y);
        for (let x = 0; x < 256; x += 8) {
          ccx.lineTo(x, y + Math.sin(x * 0.08) * 1.5);
        }
        ccx.stroke();
      }
      // Flecken (für used look)
      for (let i = 0; i < 8; i++) {
        ccx.fillStyle = `rgba(${60 + Math.random()*40}, ${40 + Math.random()*20}, 20, ${0.06 + Math.random() * 0.08})`;
        ccx.beginPath();
        ccx.arc(Math.random() * 256, Math.random() * 256, 10 + Math.random() * 20, 0, Math.PI * 2);
        ccx.fill();
      }
      // Logo / text
      ccx.fillStyle = 'rgba(45, 28, 12, 0.55)';
      ccx.font = 'bold 22px sans-serif';
      ccx.textAlign = 'center';
      ccx.fillText('FERMANIA', 128, 118);
      ccx.font = 'bold 10px sans-serif';
      ccx.fillText('— HANDLE WITH CARE —', 128, 140);
      // Runder Stempel
      ccx.strokeStyle = 'rgba(45, 28, 12, 0.4)';
      ccx.lineWidth = 2;
      ccx.beginPath();
      ccx.arc(40, 40, 22, 0, Math.PI * 2);
      ccx.stroke();
      ccx.font = 'bold 7px sans-serif';
      ccx.fillStyle = 'rgba(45, 28, 12, 0.4)';
      ccx.fillText('FRAGILE', 40, 43);
      const cardTex = new THREE.CanvasTexture(cardCanvas);
      cardTex.encoding = THREE.sRGBEncoding;

      const panelMat = new THREE.MeshStandardMaterial({
        map: cardTex, roughness: 0.88, metalness: 0.02
      });
      const flapMat = new THREE.MeshStandardMaterial({
        map: cardTex, roughness: 0.88, metalness: 0.02, side: THREE.DoubleSide
      });

      // Boden
      const bottomGeo = new THREE.PlaneGeometry(boxSize, boxSize);
      const bottom = new THREE.Mesh(bottomGeo, panelMat);
      bottom.rotation.x = -Math.PI / 2;
      bottom.position.y = -boxSize / 2;
      boxGroup.add(bottom);

      // 4 Seitenwände
      const sideGeo = new THREE.PlaneGeometry(boxSize, boxSize);
      const sides = [
        { rx: 0, ry: 0, px: 0, py: 0, pz: boxSize/2 },
        { rx: 0, ry: Math.PI, px: 0, py: 0, pz: -boxSize/2 },
        { rx: 0, ry: Math.PI/2, px: boxSize/2, py: 0, pz: 0 },
        { rx: 0, ry: -Math.PI/2, px: -boxSize/2, py: 0, pz: 0 }
      ];
      sides.forEach(s => {
        const panel = new THREE.Mesh(sideGeo, panelMat);
        panel.rotation.set(s.rx, s.ry, 0);
        panel.position.set(s.px, s.py, s.pz);
        boxGroup.add(panel);
      });

      // 4 Klappen: jede Plane wird so konstruiert, dass sie in closed state flach auf dem Deckel liegt
      // Open state = rotation um ihre Hinge-Achse, sodass Flap nach oben steht
      const flapShort = boxSize / 2;      // Deckel-Tiefe (half of top)
      const flapLong  = boxSize - 0.02;   // Deckel-Breite (full of top)
      const flapYOffset = 0.003;          // winziger Y-Versatz gegen z-fighting

      function buildFlap(config) {
        const pivot = new THREE.Group();
        pivot.position.set(config.px, boxSize/2 + config.yOffset, config.pz);
        // Plane in XZ-Ebene (horizontal), face +Y (deckel oben)
        const geo = new THREE.PlaneGeometry(config.w, config.h);
        geo.rotateX(-Math.PI / 2);
        // Plane body zum Box-Zentrum hin verschieben (hinge an pivot kante)
        geo.translate(config.tx, 0, config.tz);
        const mesh = new THREE.Mesh(geo, flapMat);
        pivot.add(mesh);
        pivot.userData.axis = config.axis;
        pivot.userData.openValue = config.openValue;
        return pivot;
      }
      // Front flap: hinge at front edge, extends backward (-Z) into box
      const flapFront = buildFlap({
        px: 0, pz: boxSize/2, yOffset: flapYOffset,
        w: flapLong, h: flapShort,
        tx: 0, tz: -flapShort / 2,
        axis: 'x', openValue: Math.PI / 2
      });
      // Back flap: hinge at back edge, extends forward (+Z) into box
      const flapBack = buildFlap({
        px: 0, pz: -boxSize/2, yOffset: flapYOffset,
        w: flapLong, h: flapShort,
        tx: 0, tz: flapShort / 2,
        axis: 'x', openValue: -Math.PI / 2
      });
      // Right flap: hinge at right edge, extends left (-X) into box
      const flapRight = buildFlap({
        px: boxSize/2, pz: 0, yOffset: 0,
        w: flapShort, h: flapLong,
        tx: -flapShort / 2, tz: 0,
        axis: 'z', openValue: -Math.PI / 2
      });
      // Left flap: hinge at left edge, extends right (+X) into box
      const flapLeft = buildFlap({
        px: -boxSize/2, pz: 0, yOffset: 0,
        w: flapShort, h: flapLong,
        tx: flapShort / 2, tz: 0,
        axis: 'z', openValue: Math.PI / 2
      });
      boxGroup.add(flapFront, flapBack, flapRight, flapLeft);
      const flaps = [flapFront, flapBack, flapRight, flapLeft];

      // Klebeband oben (wird sichtbar wenn box geschlossen)
      const tapeGeo = new THREE.PlaneGeometry(boxSize * 0.95, 0.12);
      const tapeMat = new THREE.MeshStandardMaterial({ color: 0xe8d5a8, roughness: 0.4, metalness: 0.0, transparent: true, opacity: 0.85, side: THREE.DoubleSide });
      const tape = new THREE.Mesh(tapeGeo, tapeMat);
      tape.rotation.x = -Math.PI / 2;
      tape.position.y = boxSize/2 + 0.01;
      tape.visible = false;
      boxGroup.add(tape);

      boxGroup.scale.setScalar(0);
      boxGroup.visible = false;
      scene.add(boxGroup);

      function setFlapsOpenness(o) {
        // o 0 = closed (flap flach auf deckel), 1 = open (flap steht vertikal auf)
        flaps.forEach(f => {
          const target = f.userData.openValue * o;
          if (f.userData.axis === 'x') f.rotation.set(target, 0, 0);
          else if (f.userData.axis === 'z') f.rotation.set(0, 0, target);
        });
      }

      // ==== MÜNZEN ====
      const coinsGroup = new THREE.Group();
      const coinGeo = new THREE.CylinderGeometry(0.12, 0.12, 0.025, 16);
      const coinMat = new THREE.MeshStandardMaterial({ color: 0xf0c040, roughness: 0.3, metalness: 0.7, emissive: 0x221100, emissiveIntensity: 0.3 });
      const COIN_COUNT = 10;
      const coins = [];
      for (let i = 0; i < COIN_COUNT; i++) {
        const coin = new THREE.Mesh(coinGeo, coinMat);
        coin.userData = {
          baseAngle: (i / COIN_COUNT) * Math.PI * 2,
          baseRadius: 0.8 + Math.random() * 0.5,
          offset: i * 0.08,
          // Per-Coin individuelle Rotation-Speeds in rad/ms — jede Münze hat eigenes Tempo
          // und Richtung auf X/Y/Z, sodass keine zwei Münzen synchron drehen.
          rotSpeedX: (Math.random() - 0.5) * 0.0008,
          rotSpeedY: 0.0010 + Math.random() * 0.0016,
          rotSpeedZ: (Math.random() - 0.5) * 0.0006,
          // Initial-Random-Rotation damit Münzen nicht alle gleich orientiert starten
          initRotX: Math.random() * Math.PI,
          initRotY: Math.random() * Math.PI * 2,
          initRotZ: Math.random() * Math.PI
        };
        coin.rotation.set(
          coin.userData.initRotX,
          coin.userData.initRotY,
          coin.userData.initRotZ
        );
        coins.push(coin);
        coinsGroup.add(coin);
      }
      coinsGroup.scale.setScalar(0);
      scene.add(coinsGroup);

      // ==== STAGING: Ground-Shadow, Glow-Halo, Sparkle-Burst ====
      // Weiche, radiale Canvas-Textur — wird für Schatten + Glow in zwei Varianten genutzt.
      function makeRadialTex(inner, outer, softness) {
        const s = 128;
        const c = document.createElement('canvas');
        c.width = s; c.height = s;
        const cx = c.getContext('2d');
        const g = cx.createRadialGradient(s/2, s/2, 0, s/2, s/2, s/2);
        g.addColorStop(0, inner);
        g.addColorStop(softness, outer);
        g.addColorStop(1, 'rgba(0,0,0,0)');
        cx.fillStyle = g;
        cx.fillRect(0, 0, s, s);
        const t = new THREE.CanvasTexture(c);
        t.encoding = THREE.sRGBEncoding;
        return t;
      }

      // Contact-Shadow — gibt den Objekten "Boden", vermeidet schwebenden Render-Look
      const shadowTex = makeRadialTex('rgba(20, 10, 0, 0.55)', 'rgba(20, 10, 0, 0.18)', 0.45);
      const shadowMat = new THREE.MeshBasicMaterial({
        map: shadowTex, transparent: true, depthWrite: false, opacity: 0
      });
      const shadowPlane = new THREE.Mesh(new THREE.PlaneGeometry(2.2, 1.1), shadowMat);
      shadowPlane.rotation.x = -Math.PI / 2;
      shadowPlane.position.y = -0.72;
      scene.add(shadowPlane);


      // Sparkle-Burst beim Flasche-in-Karton-Drop — der "Wow"-Moment
      const SPARKLE_COUNT = isSmallViewport ? 50 : 110;
      const sparklePositions = new Float32Array(SPARKLE_COUNT * 3);
      const sparkleSeeds = [];
      for (let i = 0; i < SPARKLE_COUNT; i++) {
        const ang = Math.random() * Math.PI * 2;
        const r = 0.30 + Math.random() * 0.70;
        const vy = 0.5 + Math.random() * 1.1;
        sparkleSeeds.push({ ang, r, vy, life: 0.5 + Math.random() * 0.5 });
        sparklePositions[i * 3 + 0] = 0;
        sparklePositions[i * 3 + 1] = 0;
        sparklePositions[i * 3 + 2] = 0;
      }
      const sparkleGeo = new THREE.BufferGeometry();
      sparkleGeo.setAttribute('position', new THREE.BufferAttribute(sparklePositions, 3));
      const sparkleTex = makeRadialTex('rgba(255, 245, 215, 1)', 'rgba(255, 200, 100, 0.8)', 0.4);
      const sparkleMat = new THREE.PointsMaterial({
        map: sparkleTex, size: 0.26, transparent: true, depthWrite: false,
        blending: THREE.AdditiveBlending, opacity: 0, sizeAttenuation: true
      });
      const sparkles = new THREE.Points(sparkleGeo, sparkleMat);
      // WICHTIG: Bei AdditiveBlending kontrolliert opacity nur den Alpha-Kanal, RGB wird trotzdem
      // addiert. 60 Punkte gestackt am Origin würden also auch bei opacity=0 als überhellte
      // Scheibe rendern und vom CSS-drop-shadow als Halo aufs Handy bluten. Daher per .visible
      // togglen und nicht nur über opacity.
      sparkles.visible = false;
      scene.add(sparkles);

      // ==== AMBIENT-BLÄSCHEN (Hintergrund) ====
      // KEIN transmission auf Bläschen — jedes transmissive Mesh kostet einen extra
      // Renderer-Capture-Pass pro Frame. 12 Bubbles à transmission war der GPU-Sättiger.
      // Stattdessen: hohe Iridescence + Clearcoat + envMapIntensity → Glas-Anmutung
      // durch Reflexion, nicht durch Lichtdurchgang. Optisch fast identisch, deutlich günstiger.
      // Original-Glas-Look mit Transmission — User hat den Look explizit zurückgewünscht.
      // Einziger Perf-Saver: iridescenceThicknessRange uniform statt variabel (Tier-S-Tweak).
      // Warmer Honig-Tint statt pures Weiß: vor dem hellen Backdrop refraktieren transmissive
      // Bubbles ein cream-gold Bild durch — als Pure-White wurde das zu einem White-Wash.
      // Mit attenuationColor + dünnem thickness kriegen sie eigene Farbidentität: warmer Honig
      // im Glaskörper, der nur an Glanzkanten in pure Iridescent-Schimmer übergeht.
      // Stark getöntes Honig-Glas mit dünner Iridescence — verhindert dass die Bubbles
      // vor dem hellen Backdrop einfach weiß werden. Tiefer thickness + close attenuation =
      // sichtbare Honig-Färbung im Glaskörper. Iridescence runter = weniger weißer Schimmer.
      const bubbleMat = new THREE.MeshPhysicalMaterial({
        color: 0xffd896,
        transmission: 1.0,
        roughness: 0.06,
        thickness: 1.4,
        ior: 1.34,
        clearcoat: 1.0,
        clearcoatRoughness: 0.08,
        metalness: 0.0,
        attenuationColor: new THREE.Color(0xc88a32),
        attenuationDistance: 0.35,
        envMapIntensity: 1.2,
        iridescence: 0.5,
        iridescenceIOR: 1.3,
        iridescenceThicknessRange: [300, 300],
        transparent: true
      });
      const BUBBLE_COUNT = isSmallViewport ? 3 : 8;
      const bubbleGeo = new THREE.SphereGeometry(1, isSmallViewport ? 16 : 24, isSmallViewport ? 16 : 24);
      const bubbles = [];
      function rand(a, b) { return a + Math.random() * (b - a); }
      function spawnBubble(b, initial) {
        const radius = rand(0.06, 0.20);
        b.scale.setScalar(radius);
        b.userData = {
          baseX: rand(-2.6, 2.6),
          y: initial ? rand(-2.6, 2.6) : -2.6 - radius - rand(0, 0.8),
          z: rand(-5.4, -4.0),
          speed: rand(0.00018, 0.00045),
          wiggleAmp: rand(0.04, 0.12),
          wigglePhase: rand(0, Math.PI * 2),
          wiggleSpeed: rand(0.0003, 0.0008),
          radius
        };
      }
      for (let i = 0; i < BUBBLE_COUNT; i++) {
        const b = new THREE.Mesh(bubbleGeo, bubbleMat);
        spawnBubble(b, true);
        b.position.z = b.userData.z;
        scene.add(b);
        bubbles.push(b);
      }
      function updateBubbles(t, dt) {
        for (let i = 0; i < bubbles.length; i++) {
          const b = bubbles[i];
          const d = b.userData;
          d.y += d.speed * dt;
          const wig = Math.sin(t * d.wiggleSpeed + d.wigglePhase) * d.wiggleAmp;
          b.position.x = d.baseX + wig;
          b.position.y = d.y;
          b.rotation.y += 0.0008 * dt;
          if (d.y > 2.7 + d.radius) spawnBubble(b, false);
        }
      }

      // ==== STATIONS / PATH ====
      const stations = Array.from(root.querySelectorAll('.station'));
      const pathEl = root.querySelector('.affiliate-journey__path');
      const pathNodes = Array.from(root.querySelectorAll('.path-node'));

      const stationRanges = [
        [0.00, 0.22],
        [0.25, 0.47],
        [0.50, 0.72],
        [0.75, 1.00]
      ];

      function updateStations(progress) {
        stations.forEach((el, i) => {
          const [start, end] = stationRanges[i];
          let alpha = 0;
          let y = 20;
          if (progress >= start && progress <= end) {
            const local = (progress - start) / (end - start);
            if (local < 0.15) alpha = local / 0.15;
            else if (local > 0.85) alpha = (1 - local) / 0.15;
            else alpha = 1;
            y = (1 - alpha) * 20;
          }
          el.style.opacity = alpha;
          el.style.transform = `translateY(${y}px)`;
        });
        let activeIdx = 0;
        for (let i = 0; i < stationRanges.length; i++) {
          if (progress >= stationRanges[i][0]) activeIdx = i;
        }
        pathNodes.forEach((node, i) => {
          node.classList.toggle('is-active', i <= activeIdx);
        });
        if (pathEl) pathEl.style.setProperty('--journey-progress', progress.toFixed(3));
      }

      // ==== ANIMATION ====
      function clamp01(v) { return Math.max(0, Math.min(1, v)); }
      function tri(v, a, b) {
        if (v < 0) return 0;
        if (v < a) return v / a;
        if (v <= b) return 1;
        if (v < 1) return (1 - v) / (1 - b);
        return 0;
      }
      function ease(v) { return v * v * (3 - 2 * v); }
      function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
      function easeInCubic(t) { return t * t * t; }

      // ==== WOW-MOMENT: Impact-Detection bei p=0.73 (Flasche fällt in Karton) ====
      // Bei jedem Cross der Schwelle (vor- oder rückwärts) wird impactTime auf jetzt gesetzt.
      // Render-Loop liest impactAge und applied Flash + Shake mit Decay.
      const IMPACT_P = 0.73;
      let lastImpactP = 0;
      let impactTime = -10000;
      const IMPACT_DURATION = 380; // ms

      function updateScene(p) {
        applyParallax(p);
        // Impact-Detection — fired wenn p die Schwelle in beide Richtungen kreuzt
        if ((lastImpactP < IMPACT_P && p >= IMPACT_P) ||
            (lastImpactP > IMPACT_P && p <= IMPACT_P)) {
          impactTime = performance.now();
        }
        lastImpactP = p;
        // Flaschen-Rotation NICHT mehr scroll-gebunden — kontinuierlich in applyFloat() unten

        // PHASE 1 (0.00-0.25): Phone + Flasche
        const s1 = clamp01((p - 0.00) / 0.25);
        const s1Vis = tri(s1, 0.1, 0.9);
        phoneGroup.scale.setScalar(s1Vis);
        phoneGroup.position.x = (-0.9 - (1 - s1Vis) * 0.5) * PHONE_X_FACTOR;

        // PHASE 2 (0.25-0.5): Cursor tappt
        const s2 = clamp01((p - 0.25) / 0.25);
        const s2Vis = tri(s2, 0.1, 0.9);
        cursorGroup.scale.setScalar(s2Vis * (1 + Math.sin(p * 40) * 0.18));
        cursorGroup.position.set(0.45 - s2 * 0.3, 0.25 - s2 * 0.1, 0.4);

        // PHASE 3 (0.50–0.87): Karton + Flasche Choreografie ("Verpack-Geste")
        //   0.50 → 0.58  Karton slidet von rechts rein
        //   0.58 → 0.63  Karton + Flasche gemeinsam Z-Schub rückwärts, Flasche driftet nach links
        //   0.63 → 0.67  Flasche wird angehoben (über Kartonoberkante), seitlich gekippt, geschrumpft
        //   0.67 → 0.70  Flasche wandert horizontal über die Kartonmitte (bleibt oberhalb der Wände)
        //   0.70 → 0.73  Flasche sinkt senkrecht in den Karton
        //   0.73 → 0.77  Klappen schließen, Tape erscheint
        //   0.77 → 0.87  Karton + Flasche fliegen rechts raus & schrumpfen
        const P3_START        = 0.50;
        const BOX_ARRIVED     = 0.58;
        const BOX_SETTLED     = 0.63;
        const BOTTLE_LIFTED   = 0.67;
        const BOTTLE_CENTERED = 0.70;
        const BOTTLE_LANDED   = 0.73;
        const FLAPS_SEALED    = 0.77;
        const BOX_GONE        = 0.87;

        // Z_BACK: deutlicher Rückwärtsschub. Auf Mobile nicht zu tief, damit Karton + Flasche
        // bei schmalem Portrait-Aspekt nicht zu winzig werden.
        const Z_BACK = isSmallViewport ? -2.8 : -3.2;
        const BOTTLE_IN_BOX_Y = -0.15;
        const BOTTLE_IN_BOX_SCALE = 0.5;
        // Lift-Waypoint. LIFT_X auf Mobile enger, weil der Portrait-Frame horizontal knapp ist
        // (bei aspect≈0.46 und z=-2.8 liegt die sichtbare Halbbreite bei ~1.04).
        // LIFT_Y so, dass die Flasche (LIFT_SCALE=0.7) mit Unterrand (-0.6*0.7=-0.42) über der
        // Kartonoberkante (y=0.6) schwebt: LIFT_Y - 0.42 > 0.6 → 1.1 mit Puffer.
        const LIFT_X     = isSmallViewport ? -0.95 : -1.6;
        const LIFT_Y     =  1.1;
        const LIFT_SCALE =  0.7;
        const LIFT_TILT  =  0.4; // rad, ≈ 23°, seitliche Z-Neigung

        let bottleX = 0, bottleY = 0, bottleZ = 0, bottleScale = 1, bottleTilt = 0;

        if (p >= P3_START && p < BOX_GONE) {
          boxGroup.visible = true;
          let boxX = 0, boxZ = 0, boxScale = 1, boxRotY = 0;
          let flapsOpen = 1;

          if (p < BOX_ARRIVED) {
            // Karton slidet von rechts rein, Flasche weicht synchron nach links aus
            const t = (p - P3_START) / (BOX_ARRIVED - P3_START);
            const tE = easeOutCubic(t);
            boxX = 3.5 * (1 - tE);
            bottleX = LIFT_X * tE;
            bottleY = 0.015 * Math.sin(p * 18);
          } else if (p < BOX_SETTLED) {
            // Karton + Flasche gemeinsam Z rückwärts, Flasche bleibt links
            const t = ease((p - BOX_ARRIVED) / (BOX_SETTLED - BOX_ARRIVED));
            boxZ = Z_BACK * t;
            bottleZ = Z_BACK * t;
            bottleX = LIFT_X;
          } else if (p < BOTTLE_LIFTED) {
            // Lift: Flasche hebt sich über die Kartonoberkante, kippt zur Seite, schrumpft
            const t = ease((p - BOX_SETTLED) / (BOTTLE_LIFTED - BOX_SETTLED));
            boxZ = Z_BACK;
            bottleX = LIFT_X;
            bottleY = LIFT_Y * t;
            bottleZ = Z_BACK;
            bottleScale = 1 - t * (1 - LIFT_SCALE);
            bottleTilt = LIFT_TILT * t;
          } else if (p < BOTTLE_CENTERED) {
            // Horizontal-Transit: Flasche wandert über den Karton — oben drüber, nicht durch die Wand
            const t = ease((p - BOTTLE_LIFTED) / (BOTTLE_CENTERED - BOTTLE_LIFTED));
            boxZ = Z_BACK;
            bottleX = LIFT_X * (1 - t);
            bottleY = LIFT_Y;
            bottleZ = Z_BACK;
            bottleScale = LIFT_SCALE;
            bottleTilt = LIFT_TILT * (1 - t);
          } else if (p < BOTTLE_LANDED) {
            // Drop: Flasche sinkt senkrecht durch den offenen Deckel in den Karton
            const t = ease((p - BOTTLE_CENTERED) / (BOTTLE_LANDED - BOTTLE_CENTERED));
            boxZ = Z_BACK;
            bottleX = 0;
            bottleY = LIFT_Y + (BOTTLE_IN_BOX_Y - LIFT_Y) * t;
            bottleZ = Z_BACK;
            bottleScale = LIFT_SCALE + (BOTTLE_IN_BOX_SCALE - LIFT_SCALE) * t;
            bottleTilt = 0;
          } else if (p < FLAPS_SEALED) {
            const t = (p - BOTTLE_LANDED) / (FLAPS_SEALED - BOTTLE_LANDED);
            boxZ = Z_BACK;
            bottleZ = Z_BACK;
            bottleY = BOTTLE_IN_BOX_Y;
            bottleScale = BOTTLE_IN_BOX_SCALE;
            flapsOpen = 1 - ease(t);
          } else {
            const t = (p - FLAPS_SEALED) / (BOX_GONE - FLAPS_SEALED);
            const shrink = Math.max(0, 1 - t * 1.3);
            const flyX = easeInCubic(t) * 4.0;
            boxX = flyX;
            boxZ = Z_BACK * (1 - t);
            boxScale = shrink;
            boxRotY = t * 0.55;
            flapsOpen = 0;
            bottleX = flyX;
            // Karton schrumpft um sein lokales Zentrum (y=0). Damit die Flasche optisch
            // im Karton bleibt statt unten herauszurutschen, muss ihr Y-Offset mitschrumpfen.
            bottleY = BOTTLE_IN_BOX_Y * shrink;
            bottleZ = boxZ;
            bottleScale = BOTTLE_IN_BOX_SCALE * shrink;
          }

          boxGroup.position.set(boxX, 0, boxZ);
          boxGroup.scale.setScalar(boxScale);
          boxGroup.rotation.y = boxRotY;
          setFlapsOpenness(flapsOpen);
          tape.visible = p >= BOTTLE_LANDED;
        } else {
          boxGroup.visible = false;
          tape.visible = false;
          if (p >= BOX_GONE) bottleScale = 0;
        }

        bottleGroup.position.set(bottleX, bottleY, bottleZ);
        bottleGroup.userData.anchorY = bottleY;
        bottleGroup.scale.setScalar(bottleScale);
        bottleGroup.rotation.x = 0;
        bottleGroup.rotation.z = bottleTilt;

        // PHASE 4 (0.87-1.0): Münzen fliegen aus der weggeflogenen Box zurück
        const s4 = clamp01((p - 0.87) / 0.13);
        const s4Vis = tri(s4, 0.1, 1);
        coinsGroup.scale.setScalar(s4Vis);
        coins.forEach((coin, i) => {
          const t = s4 * 2 + coin.userData.offset;
          const angle = coin.userData.baseAngle + t * 0.6;
          const startX = 2.2; // Position wo Box weggeflogen ist
          const spread = s4 * 2 + 0.3;
          // Münzen fliegen VON startX ZURÜCK nach links (zum Creator)
          coin.position.x = startX - s4 * 3.0 + Math.cos(angle) * spread * 0.3 * coin.userData.baseRadius;
          coin.position.y = Math.sin(angle) * spread * 0.5 * coin.userData.baseRadius + Math.sin(t * 2) * 0.1;
          coin.position.z = (i % 2 === 0 ? 0.1 : -0.1) + Math.sin(t) * 0.1;
          // Rotation NICHT mehr scroll-gebunden — kontinuierlich pro Frame in applyFloat()
        });

        // ==== STAGING-UPDATES ====
        // Contact-Shadow folgt dem Haupt-Subjekt: Flasche in P1/P2, Karton in P3, fade in P4
        let shadowX, shadowZ, shadowScale, shadowAlpha;
        if (p < P3_START) {
          shadowX = 0; shadowZ = 0; shadowScale = 1.0;
          shadowAlpha = tri(p / P3_START, 0.15, 0.9) * 0.9;
        } else if (p < BOX_GONE) {
          // Schatten unter dem Karton (boxGroup.position)
          shadowX = boxGroup.position.x;
          shadowZ = boxGroup.position.z;
          // Perspektivisch kleiner je tiefer in Z
          shadowScale = 1.0 + shadowZ * 0.18;
          shadowAlpha = 0.85 * boxGroup.scale.x;
        } else {
          shadowX = 0; shadowZ = 0; shadowScale = 1.0;
          shadowAlpha = 0;
        }
        shadowPlane.position.x = shadowX;
        shadowPlane.position.z = shadowZ;
        shadowPlane.scale.setScalar(Math.max(0.2, shadowScale));
        shadowMat.opacity = shadowAlpha;

        // Sparkle-Burst — zündet beim Drop in den Karton, klingt mit den Klappen aus
        const SPARKLE_START = BOTTLE_CENTERED - 0.005;
        const SPARKLE_END   = FLAPS_SEALED + 0.02;
        const sparkleT = clamp01((p - SPARKLE_START) / (SPARKLE_END - SPARKLE_START));
        if (sparkleT > 0 && sparkleT < 1) {
          sparkles.visible = true;
          const arr = sparkleGeo.attributes.position.array;
          for (let i = 0; i < SPARKLE_COUNT; i++) {
            const s = sparkleSeeds[i];
            const local = clamp01(sparkleT / s.life);
            const travel = easeOutCubic(local);
            arr[i * 3]     = Math.cos(s.ang) * s.r * travel;
            arr[i * 3 + 1] = BOTTLE_IN_BOX_Y + Math.sin(s.ang) * s.r * travel + s.vy * travel * 0.6;
            arr[i * 3 + 2] = Z_BACK + Math.sin(s.ang * 1.7) * 0.15 * travel;
          }
          sparkleGeo.attributes.position.needsUpdate = true;
          sparkleMat.opacity = tri(sparkleT, 0.08, 0.55) * 0.95;
        } else {
          sparkles.visible = false;
        }

        // Cinematic Kamera-Choreografie — pro-Phase Shot-Targets, smooth interpoliert
        applyCameraShot(p);
      }

      // ==== RESIZE ====
      function resize() {
        const stickyEl = root.querySelector('.affiliate-journey__sticky');
        const rr = stickyEl.getBoundingClientRect();
        width = rr.width; height = rr.height;
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
        renderer.setSize(width, height, false);
        sizeForePlane();
        sizeMidPlane();
      }
      resize();
      let resizeTimer;
      function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => { resize(); ScrollTrigger.refresh(); }, 180);
      }
      window.addEventListener('resize', onResize);

      // ==== SCROLLTRIGGER ====
      // Desktop: scrub 0.8 → Visuals trail-en der Scroll-Position um 0.8s, gibt der Szene
      // Cinematic-Inertia (Kamera „katchpt" smooth nach statt 1:1 zu snappen).
      // Mobile: scrub true (1:1) damit iOS-Momentum-Scroll nicht mit GSAP-Tween konkurriert.
      const scrollTrigger = ScrollTrigger.create({
        trigger: root,
        start: 'top top',
        end: 'bottom bottom',
        scrub: isSmallViewport ? true : 0.8,
        onUpdate: (self) => {
          updateScene(self.progress);
          updateStations(self.progress);
        }
      });

      updateScene(0);
      updateStations(0);

      // Schweben: subtle Y-Oszillation auf den Hauptobjekten. Wird per Frame angewendet
      // (nicht per scroll-event), damit Float weiterläuft auch wenn der User nicht scrollt.
      // Pro Group ein eigener Phase-Offset damit nicht alle synchron bobben.
      function applyFloat(t) {
        const ft = t * 0.0008;
        if (bottleGroup.visible) {
          const anchor = bottleGroup.userData.anchorY != null ? bottleGroup.userData.anchorY : 0;
          bottleGroup.position.y = anchor + Math.sin(ft) * 0.020;
          // Kontinuierliche Y-Rotation, time-driven (unabhängig vom Scroll)
          bottleGroup.rotation.y = t * 0.0006;
        }
        if (phoneGroup.visible) {
          phoneGroup.position.y = Math.sin(ft + 1.5) * 0.025;
        }
        if (boxGroup.visible) {
          boxGroup.position.y = Math.sin(ft + 2.5) * 0.012;
        }
        // Münzen — jede mit individueller Rotation, time-driven (läuft auch ohne Scroll).
        // dt clamp damit bei rAF-Hängern keine extreme Sprünge passieren.
        const dtClamped = Math.min(t - (applyFloat._lastT || t), 50);
        applyFloat._lastT = t;
        for (let i = 0; i < coins.length; i++) {
          const d = coins[i].userData;
          coins[i].rotation.x += d.rotSpeedX * dtClamped;
          coins[i].rotation.y += d.rotSpeedY * dtClamped;
          coins[i].rotation.z += d.rotSpeedZ * dtClamped;
        }
        // Backdrop-Shader-Time fortschreiben (für slow Noise-Drift)
        if (backdropMat) backdropMat.uniforms.uTime.value = t * 0.0005;
      }

      // ==== RENDER LOOP ====
      let rafId = null, paused = false, lastT = performance.now();
      function loop(t) {
        const dt = Math.min(t - lastT, 50);
        lastT = t;
        if (!useVideo) drawReel(t); // Fallback-Canvas permanent aktualisieren
        updateBubbles(t, dt);
        applyFloat(t);
        applyCameraFinal();
        renderer.render(scene, camera);
        if (!paused) rafId = requestAnimationFrame(loop);
      }

      const io = new IntersectionObserver(entries => {
        for (const e of entries) {
          if (e.isIntersecting) {
            paused = false;
            if (!rafId) rafId = requestAnimationFrame(loop);
          } else {
            paused = true;
            if (rafId) cancelAnimationFrame(rafId);
            rafId = null;
          }
        }
      }, { threshold: 0 });
      io.observe(root);

      rafId = requestAnimationFrame(loop);

      root._journeyCleanup = function cleanup() {
        paused = true;
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        io.disconnect();
        scrollTrigger.kill();
        window.removeEventListener('resize', onResize);
        clearTimeout(resizeTimer);
        scene.traverse(obj => {
          if (obj.geometry) obj.geometry.dispose();
          if (!obj.material) return;
          const mats = Array.isArray(obj.material) ? obj.material : [obj.material];
          mats.forEach(m => {
            Object.values(m).forEach(v => v && v.isTexture && v.dispose());
            m.dispose();
          });
        });
        if (scene.environment) scene.environment.dispose();
        if (scene.background && scene.background.isTexture) scene.background.dispose();
        if (reelTex) reelTex.dispose();
        renderer.dispose();
        if (renderer.forceContextLoss) renderer.forceContextLoss();
        root._journeyInit = false;
        delete root._journeyCleanup;
      };
    }).catch(err => {
      console.error('Journey libs load failed', err);
      root._journeyInit = false;
    });
    /* === END AKTIVE 3D-VARIANTE ================================================ */
  }

  document.addEventListener('shopify:section:load', (e) => {
    const r = e.target && e.target.querySelector && e.target.querySelector('[data-affiliate-journey]');
    if (r) initJourney(r);
  });
  document.addEventListener('shopify:section:unload', (e) => {
    const r = e.target && e.target.querySelector && e.target.querySelector('[data-affiliate-journey]');
    if (r && r._journeyCleanup) r._journeyCleanup();
  });
})();
